module.exports = __webpack_public_path__ + "static/img/product_manufacture_UniStlCCasting.8173515.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_manufacture_UniStlCCasting.png
// module id = x6m4
// module chunks = 0